// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"112":"f8874471","391":"f15516c4","594":"4b168611","673":"412c582d","755":"0b65e1ec"}[chunkId] + ".css";
};